/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PersonFillIcon = function PersonFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M12 12C14.2092 12 16 10.2091 16 8C16 5.79086 14.2092 4 12 4C9.79088 4 8.00001 5.79086 8.00001 8C8.00001 10.2091 9.79088 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52461 18.7226C4.20477 15.3396 7.81606 13 12 13C16.184 13 19.7953 15.3396 21.4754 18.7226C21.7783 19.3325 21.2991 20 20.6181 20H3.38194C2.70097 20 2.2217 19.3325 2.52461 18.7226Z"
  }));
};
export default PersonFillIcon;